import LoginBody from "@/components/landing/auth/LoginBody";

export default function LoginPage() {
  return <LoginBody />;
}
